exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-finger-thief-js": () => import("./../../../src/pages/finger-thief.js" /* webpackChunkName: "component---src-pages-finger-thief-js" */),
  "component---src-pages-gotta-light-js": () => import("./../../../src/pages/gotta-light.js" /* webpackChunkName: "component---src-pages-gotta-light-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-works-js": () => import("./../../../src/pages/works.js" /* webpackChunkName: "component---src-pages-works-js" */)
}

